export const CheckmarkIcon = () => {
	return (
		<svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M1 6L5.66118 11L15 1" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	)
}
